import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'cpf' })
export class CpfPipe implements PipeTransform {

  transform(value: string): string | undefined {
    if (value?.length !== 11) {
      return undefined;
    }
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
}
